export default __webpack_public_path__ + "static/media/Morphosoric_bg.1606fe6e.jpg";